import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { useAppScopeStore } from '@frontend/scope';
import type { LocationPhoneSelection } from '@frontend/thread-header-context';
import { theme } from '@frontend/theme';
import { PopoverMenuItem, Text, Truncated, usePopoverMenu } from '@frontend/design-system';
import { PopoverMenuHeader } from './popover-menu-header';

type Props = {
  getItemProps: ReturnType<typeof usePopoverMenu>['getItemProps'];
  locationOptions: string[];
  onBack: () => void;
  onSelectLocation: (locationId: string) => void;
  selectedLocationPhone?: LocationPhoneSelection;
  showHeader: boolean;
};

export const LocationsOptions = ({
  getItemProps,
  locationOptions,
  onBack,
  onSelectLocation,
  selectedLocationPhone,
  showHeader,
}: Props) => {
  const { t } = useTranslation('inbox');
  const { getScopeName } = useAppScopeStore();

  return (
    <>
      {showHeader && (
        <PopoverMenuHeader getItemProps={getItemProps} onBack={onBack} title={t('All Outbound Numbers')} />
      )}
      {locationOptions.map((locationId) => (
        <PopoverMenuItem
          key={locationId}
          {...getItemProps({
            index: 0,
            onClick: () => onSelectLocation(locationId),
            disableCloseOnSelect: true,
          })}
          trackingId='location-phone-conversation-submenu'
          css={{ justifyContent: 'space-between', width: '100%' }}
        >
          <div css={{ display: 'flex', alignItems: 'center', maxWidth: 'calc(100% - 24px)' }}>
            <Icon name='location' css={{ marginRight: theme.spacing(1), minWidth: 16 }} />
            <Truncated
              css={{ fontWeight: selectedLocationPhone?.locationId ? 'bold' : 'normal', textAlign: 'left' }}
              as={Text}
            >
              {getScopeName(locationId)}
            </Truncated>
          </div>
          {selectedLocationPhone?.locationId && <Icon name='alt-caret-right-tiny' css={{ minWidth: 16 }} />}
        </PopoverMenuItem>
      ))}
    </>
  );
};
